(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-finder-quiz"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Order must match the metafield combination string: Height | Weight | Users | Duration.
    var QUESTIONS = ['height', 'weight', 'users', 'duration'];
    var COMBO_SEPARATOR = ' | ';

    function initQuiz(root) {
      if (root.dataset.ipsInit === 'true') return;
      root.dataset.ipsInit = 'true';

      var sections = root.querySelectorAll('.js-ips-section');
      var recommendationsBlock = root.querySelector('.js-ips-products');
      var products = root.querySelectorAll('.js-ips-product');
      var emptyState = root.querySelector('.js-ips-empty');

      function parseList(value) {
        if (!value) return [];
        try {
          var parsed = JSON.parse(value);
          return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
          return [];
        }
      }

      // selected answer label per question, read from the visible buttons
      function getSelections() {
        var sel = {};
        sections.forEach(function (section) {
          var chosen = section.querySelector('.js-ips-item.selected');
          if (chosen) sel[section.dataset.question] = chosen.textContent.trim();
        });
        return sel;
      }

      // Build the user's combination, e.g. "6'/183 cm & Above | 100~120 kg | 1 User | 30 ~ 60 Minutes".
      // Uses the visible labels, so it can't drift from what the buttons show.
      function buildCombination(selections) {
        return QUESTIONS.map(function (q) {
          return selections[q];
        }).join(COMBO_SEPARATOR);
      }

      // A product matches if its combination list contains the user's combination.
      function productMatches(product, userCombination) {
        return parseList(product.dataset.combinations).indexOf(userCombination) !== -1;
      }

      function recommend() {
        var selections = getSelections();
        var answeredCount = Object.keys(selections).length;
        var complete = answeredCount === sections.length;

        if (!complete) {
          recommendationsBlock.classList.add('hide-recommendations');
          return;
        }

        recommendationsBlock.classList.remove('hide-recommendations');

        // Show every product; highlight the matches and bounce the new ones.
        var userCombination = buildCombination(selections);
        var matchCount = 0;
        products.forEach(function (product) {
          product.classList.remove('hide');
          var isMatch = productMatches(product, userCombination);
          var alreadyHighlighted = product.classList.contains('show');

          if (isMatch) {
            matchCount++;
            if (!alreadyHighlighted) {
              product.classList.remove('animated', 'bounceIn');
              void product.offsetWidth; // reflow so the animation replays
              product.classList.add('show', 'animated', 'bounceIn');
            }
          } else {
            product.classList.remove('show', 'animated', 'bounceIn');
          }
        });

        if (emptyState) emptyState.classList.toggle('hide', matchCount > 0);

        // Scroll down on every answer change once complete.
        recommendationsBlock.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      root.querySelectorAll('.js-ips-item').forEach(function (item) {
        item.addEventListener('click', function () {
          item.classList.remove('off');
          item.classList.add('selected');
          var siblings = item.closest('.options').querySelectorAll('.js-ips-item');
          siblings.forEach(function (sib) {
            if (sib !== item) {
              sib.classList.remove('selected');
              sib.classList.add('off');
            }
          });
          recommend();
        });
      });
    }

    function init() {
      document.querySelectorAll('.ips-quiz').forEach(initQuiz);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
